var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01677 7.59427C1.90328 7.41457 1.84654 7.32472 1.81477 7.18614C1.79091 7.08204 1.79091 6.91788 1.81477 6.81378C1.84654 6.67519 1.90328 6.58534 2.01677 6.40564C2.95461 4.92066 5.74617 1.16663 10.0003 1.16663C14.2545 1.16663 17.0461 4.92066 17.9839 6.40564C18.0974 6.58534 18.1541 6.67519 18.1859 6.81378C18.2098 6.91788 18.2098 7.08204 18.1859 7.18614C18.1541 7.32472 18.0974 7.41457 17.9839 7.59427C17.0461 9.07926 14.2545 12.8333 10.0003 12.8333C5.74617 12.8333 2.95461 9.07926 2.01677 7.59427Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9.49996C11.381 9.49996 12.5003 8.38067 12.5003 6.99996C12.5003 5.61925 11.381 4.49996 10.0003 4.49996C8.61962 4.49996 7.50034 5.61925 7.50034 6.99996C7.50034 8.38067 8.61962 9.49996 10.0003 9.49996Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b7c3c2536692d29377acbca0cd45e403.svg";
export { ForwardRef as ReactComponent };